window.logincheckform = function(){
    document.ExtUserForm.Password.value = document.ExtUserForm.Password.value.toUpperCase();
    document.ExtUserForm.Username.value = document.ExtUserForm.Username.value.toUpperCase();
    return true;
}


// WEBPACK FOOTER //
// ./scripts/components/transUpper.js